import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { IsNotEmpty, IsOptional, IsString, IsUUID } from 'class-validator'

export class GroupDto {
  @ApiProperty({
    description: 'ID du groupe',
    example: '550e8400-e29b-41d4-a716-446655440000',
    type: 'string',
  })
  @IsNotEmpty()
  @IsUUID('4')
  id!: string

  @ApiProperty({
    description: "ID de l'établissement",
    example: '550e8400-e29b-41d4-a716-446655440000',
    type: 'string',
  })
  @IsNotEmpty()
  @IsUUID('4')
  establishmentId!: string

  @ApiProperty({
    description: 'Nom du groupe',
    example: 'Groupe A',
    type: 'string',
  })
  @IsNotEmpty()
  @IsString()
  name!: string

  @ApiPropertyOptional({
    description: 'Description du groupe',
    example: 'Groupe de travail pour les mathématiques',
    type: 'string',
  })
  @IsOptional()
  @IsString()
  description?: string

  @ApiPropertyOptional({
    description: 'ID du type de groupe',
    example: '550e8400-e29b-41d4-a716-446655440000',
    type: 'string',
  })
  @IsOptional()
  @IsUUID('4')
  typeId?: string

  @ApiPropertyOptional({
    description: "ID de l'année scolaire",
    example: '550e8400-e29b-41d4-a716-446655440000',
    type: 'string',
  })
  @IsOptional()
  @IsUUID('4')
  schoolYearId?: string
}